"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserRegistered = exports.Name = void 0;
const Name = exports.Name = 'user-registered';
const UserRegistered = exports.UserRegistered = Name;
//# sourceMappingURL=index.js.map